<template>
  <div class="cont-outer cont-outer-cont-4 mobile-bar">
      <div class="lines-left" data-scroll></div>
      <div class="lines-right" data-scroll>
        <img src="@/assets/img/kajada.png" alt="ჟ" />
      </div>
      <div class="container-landing cont-4 landing-cont" data-scroll>
        <img src="@/assets/img/sagorao.png" class="sagorao" data-scroll />
        <div class="inner-outer-wrapper">
          <div class="text-box">
            <div class="ttl-wrapper" data-scroll>
              <h2 class="f-55">{{ getCompTitle }}</h2>
            </div>
            <div class="editor" data-scroll>
            <p class="regular f-34 secondary-ttl" data-scroll>
              {{ getTitle }}
            </p>
            <div class="light-italic f-21 long-desc" v-html="getTeaser" data-scroll>

            </div>
            </div>
            <a :href="_.get(getButton, 'url')" class="read-more" data-scroll>
              <div class="inner-wrapper">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="31.675"
                  height="22.988"
                  viewBox="0 0 31.675 22.988"
                >
                  <g
                    id="Group_1464"
                    data-name="Group 1464"
                    transform="translate(25.293 -3.205)"
                  >
                    <g id="menu" transform="translate(-24.754 3.74)">
                      <g
                        id="Group_103"
                        data-name="Group 103"
                        transform="translate(0 0)"
                      >
                        <path
                          id="Union_6"
                          data-name="Union 6"
                          d="M14.188,18.549a58.283,58.283,0,0,1,7.4-5.171c.715-.424,1.448-.829,2.2-1.182-1.091-.045-2.205,0-3.308.045-1.171.049-2.329.094-3.434.039-4.772-.258-9.5-1.134-14.285-1.043-1.647.027-4.351-2.44-1.56-2.492,5.429-.1,10.753.977,16.168,1.092.9.017,1.815,0,2.742-.025a29.737,29.737,0,0,1,6.123.291C23.565,7.291,20.5,4.854,18.2,1.7c-.692-.945-.142-2.5.8-1.2,2.773,3.807,6.667,6.576,9.641,10.209a1.562,1.562,0,0,1,.248.424,1.243,1.243,0,0,1,.392.951c0,.042,0,.081,0,.118-.024.716-1.047.863-2.069.626a14.12,14.12,0,0,0-5.341,2.45,65.534,65.534,0,0,0-6.1,4.352,1.4,1.4,0,0,1-.9.3C14.039,19.925,13.278,19.3,14.188,18.549Z"
                          transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.043)"
                          fill="#101820"
                          stroke="#101820"
                          stroke-width="1"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <span class="f-30">{{ _.get(getButton, 'title') }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: [
    "contentData"
  ],
  computed: {
    getCompTitle() {
      return _.get(this.contentData, 'conf.header.title')
    },
    getTitle() {
      return _.get(this.contentData, 'data.list.0.title')
    },
    getTeaser() {
      return _.get(this.contentData, 'data.list.0.teaser')
    },
    getButton() {
      return _.get(this.contentData, 'data.list.0.optionalButtons.0')
    },
  }
}
</script>

<style lang="scss" scoped>
.cont-4{
 
  .secondary-ttl, .ttl-wrapper h2, .read-more span{
    will-change: transform;
  }
  .long-desc{
  will-change: transform;
  &::v-deep p, &::v-deep span, &::v-deep h1, &::v-deep h2, &::v-deep h3, &::v-deep h4, &::v-deep h5, &::v-deep h6, &::v-deep strong, &::v-deep i, &::v-deep mark, &::v-deep em,
   &::v-deep small, &::v-deep del, &::v-deep ins, &::v-deep sub, &::v-deep sup{
    font-family: "FiraGO-Italic";
    @media (max-width: 767px){
      font-size: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;  
      overflow: hidden;
    }
  }
  &::v-deep strong, &::v-deep b{
    font-family: "FiraGO-BoldItalic";
      @media (max-width: 767px){
      font-size: 16px;
        display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;  
      overflow: hidden;
    }
  }
  
}
}

</style>